<template>
  <div class="drawer-detail">
    <div class="field-type">
      <span class="label">{{translateTag['领导介绍']||'领导介绍'}}:</span>
      <div :class="[company['领导介绍']?'':'gray-text','value company-pre']">
        <p v-if="company['领导介绍']">{{company['领导介绍']}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit('领导介绍')"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <div class="new-hr-box">
      <div v-for="item in showCompanyLeaders" :key="item._id" class="new-hr new-leader">
        <span class="name">
          <span v-if="!item.rid">{{ item.姓名 || '' }}</span>
          <span v-else style="cursor:pointer;" @click="showRadish({ id: item.rid })">{{ item.姓名 }}</span>
        </span>
        <span>{{ item.目前职位 || '' }}</span>
      </div>
    </div>
    <!-- <div class="field-type">
      <table class="address">
        <thead>
          <td style="width:80px">姓名</td>
          <td style="width:120px">目前职位</td>
          <td style="width:100px">职级</td>
        </thead>
        <tbody>
          <tr v-for="(item, index) in showCompanyLeaders" :key="index + 2">
            <td style="width:80px">{{item['姓名']}}</td>
            <td style="width:120px">{{item['目前职位']}}</td>
            <td style="width:100px">{{item['职级']}}</td>
          </tr>
        </tbody>
      </table>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['领导介绍', '领导'],
      translateTag: {
        领导介绍: '高管整体介绍',
      },
      companyLeaders: [],
      qimingpianLeaders: [],
    }
  },
  computed: {
    showCompanyLeaders() {
      const { companyLeaders = [], qimingpianLeaders = [] } = this
      const newArr = companyLeaders.concat(qimingpianLeaders)
      return newArr
    },
    total() {
      return this.companyLeaders.concat(this.qimingpianLeaders).length
    },
  },
  watch: {
    company: {
      handler: async function (newValue, oldVal) {
        if (newValue && newValue._id && newValue._id !== (oldVal && oldVal._id)) {
          this.companyLeaders = []
          this.qimingpianLeaders = []
          await this.getCompanyLeaders()
          await this.getQimingpian()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async getCompanyLeaders() {
      const leaders = this.company.领导
      if (!leaders) return (this.companyLeaders = [])
      const res = await window.app.service('company').getLeaders(leaders)
      if (res.status === 'success') {
        this.companyLeaders = res.data
      } else {
        this.$message(res.msg)
        this.companyLeaders = []
      }
    },
    quickEdit(field){
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
    async getQimingpian() {
      if (!this.company._id) return
      const res = await app.service('company').getCompanyInvestment({ cid: this.company._id })
      if (res.status === 'success') {
        const result = res.data.投资机构 || []
        const qimingpianLeaders = []
        result.forEach((e) => {
          const index = this.companyLeaders.findIndex((v) => v.姓名 === e.姓名)
          if (index > -1) {
            if (
              e.投资案例 &&
              this.companyLeaders[index] &&
              (!this.companyLeaders[index].投资案例 || this.companyLeaders[index].投资案例.length == 0)
            ) {
              this.companyLeaders[index].投资案例 = e.投资案例.split(',').map((v) => ({ 名称: v }))
            }
            if (e.头像) {
              this.companyLeaders[index].头像 = e.头像
            }
          } else {
            const obj = Object.assign({}, e)
            obj.目前职位 = e.职位
            obj.来源 = '企查查'
            if (obj.投资案例) {
              obj.投资案例 = obj.投资案例.split(',').map((v) => ({ 名称: v }))
            }
            qimingpianLeaders.push(obj)
          }
        })
        this.qimingpianLeaders = qimingpianLeaders
      } else this.qimingpianLeaders = []
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
